// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5445":"044e8fbe88400425","6666":"8b55b2fa0d811bc9","8324":"d2780451a0a5668e"}[chunkId] + ".css";
};